<template lang="pug">
  .body.garbage-table.body-flex.bigger-first-col
    .table-choose-panel.toolbar.toolbar_no-padding.toolbar_margin-bottom
      .toolbar-table.toolbar__line.toolbar__line_flex-wrap
        e-select-list(
          :options="selectListOptions"
          v-model="operationType"
        )
        .toolbar__center(v-if="operationType === 'container' && year_meter_plan" )
          span.semibold.garbage-table__year-plan(style="margin-right:15px") Плановый годовой норматив: {{year_meter_plan}} куб. м
          span.semibold.garbage-table__year-plan Осталось распределить: {{leftVolume}} куб. м

        .toolbar.toolbar--modal.toolbar_no-padding
          .toolbar__line.line
            div.parameters
              e-year-selector(year="year")
            div.actions-panel.view-panel.view-panel_divide
              e-button-add.btn-add-target.actions-panel__button.view-panel__button.view-panel__button_add(@click="addNewRowToGarbageTable" label="Добавить" )

    e-table-editable(
      v-if="operationType === 'detail'"
      @afterEditRow="afterEditRow"
      ref="detail"
      :attributes="garbageDetailAttr"
      :dataUrl="garbageDataUrl"
      :postUrl="garbagePostUrl"
      :patchUrl="garbagePatchUrl"
      :deleteUrl="garbageDeleteUrl"
      :enableOnAdd="enableOnAdd"
      :tableInOnlineMode="tableInOnlineMode"
      :afterFetchData="afterFetchData"
      :afterValidate="afterValidate"
      @sortByField="onSortByField"
      :enablePagination="false"
      @paginate="onPaginate"
    )
    e-table-editable(
      v-if="operationType === 'input'"
      ref="input"
      :attributes="garbageInputAttr"
      :dataUrl="garbageDataUrl"
      :postUrl="garbagePostUrl"
      :patchUrl="garbagePatchUrl"
      :deleteUrl="garbageDeleteUrl"
      :enableOnAdd="enableOnAdd"
      :tableInOnlineMode="tableInOnlineMode"
      :afterFetchData="afterFetchData"
      :afterValidate="afterValidate"
    )
    e-table-editable(
      v-if="operationType === 'output'"
      ref="output"
      :attributes="garbageOutputAttr"
      :dataUrl="garbageDataUrl"
      :postUrl="garbagePostUrl"
      :patchUrl="garbagePatchUrl"
      :deleteUrl="garbageDeleteUrl"
      :enableOnAdd="enableOnAdd"
      :tableInOnlineMode="tableInOnlineMode"
      :afterFetchData="afterFetchData"
      :afterValidate="afterValidate"
    )
    e-table-editable(
      v-if="operationType === 'container' && year_meter_plans.length && !hasMsnContainerAddress"
      ref="container"
      :attributes="msnContainerAttr"
      :dataUrl="garbageMsnUrl"
      :postUrl="msnGarbagePostUrl"
      :patchUrl="msnGarbagePatchUrl"
      :deleteUrl="msnGarbageDeleteUrl"
      :enableOnAdd="containerEnableOnAdd"
      :tableInOnlineMode="tableInOnlineMode"
      :afterFetchData="afterFetchContainerData"
      :afterValidate="afterValidate"
      :prepareRow="prepareContainerRow"
      @afterSaveRow="afterSaveContainerRow"
    )
    e-table-editable(
      v-if="operationType === 'container' && year_meter_plans.length && hasMsnContainerAddress"
      ref="container"
      :attributes="msnContainerAttr"
      :dataUrl="garbageMsnUrl"
      :postUrl="msnGarbagePostUrl"
      :patchUrl="msnGarbagePatchUrl"
      :deleteUrl="msnGarbageDeleteUrl"
      :enableOnAdd="containerEnableOnAdd"
      :tableInOnlineMode="tableInOnlineMode"
      :afterFetchData="afterFetchContainerData"
      :afterValidate="afterValidate"
      :prepareRow="prepareContainerRow"
      :onToggleEditable="onToggleEditable"
      @afterSaveRow="afterSaveContainerRow"
    )
</template>

<script>
import { cadastr, core, garbage, tko, msn } from '@/api/api-endpoints'
import { garbageOffline } from '@/api/api-offline-endpoints'
import hasMixin from '@/mixins/has-mixin'
import textMixin from '@/mixins/text-mixin'
import year from '@/utils/year'
import { REGION_CONFIG } from '@/config/regions'
import { findItemByPropertyAndValue, reduceArrayByOneProperty } from '@/utils'
import url from '@/utils/url'

const transformRegion = function (model) {
  let lbl = ''
  this.regionsByCodes.forEach((v) => {
    if (v.code === model.region_code) {
      lbl = v.name
    }
  })
  return lbl
}

export default {
  name: 'garbage-table',
  mixins: [hasMixin, textMixin],
  props: {
    id: null,
    tabView: null,
    year_meter_plans: {
      type: Array,
      default: () => [],
    },
    fields: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
  data() {
    return {
      operationType: null,
      year: year.getCurrentYear(),
      search: '',
      searchModel: '',
      sort: null,
      paginationQuery: null,
      suggestedMsnGarbage: null,
      leftVolume: null,
      year_meter_plan: null,
    }
  },
  computed: {
    selectListOptions() {
      const pathsWithoutGarbage = [
        'garbage.med.update',
        'garbage.med.create',
        'garbage.individual_area.update',
        'garbage.individual_area.create',
      ]
      const items = []
      if (!this.hasOnlyContainerGarbage) {
        items.push({
          id: 'detail',
          name: 'Движение отходов',
        })

        if (this.hasTableTransferredWaste) {
          items.push({
            id: 'output',
            name: 'Сведения о переданных отходах',
          })
        }

        if (
          !pathsWithoutGarbage.includes(this.$route.name) &&
          this.hasTableReceivedWaste
        ) {
          items.push({
            id: 'input',
            name: 'Сведения о полученных отходах',
          })
        }
      } else {
        this.operationType = 'container'
      }

      if (this.year_meter_plans.length) {
        items.push({
          id: 'container',
          name: 'Места накопления отходов',
        })
      }
      return items
    },
    tableInOnlineMode() {
      return this.$route.params.id
    },
    enableOnAdd() {
      return [
        'fkkoName',
        'code',
        'start_year_value_cubic',
        'start_year_value',
        'formed',
        'formed_cubic',
        'input',
        'input_cubic',
        'used',
        'used_cubic',
        'processing',
        'processing_cubic',
        'utilization',
        'utilization_cubic',
        'utiled_to_recycle',
        'utiled_to_recycle_cubic',
        'utiled_from_process',
        'utiled_from_process_cubic',
        'neutralization',
        'neutralization_cubic',
        'neutral_from_process',
        'neutral_from_process_cubic',
        'output',
        'output_cubic',
        'storage',
        'storage_cubic',
        'burial',
        'burial_cubic',
        'end_year_value',
        'end_year_value_cubic',
        'total',
        'total_cubic',
        'count',
        'count_cubic',
        'region_code',
      ]
    },
    // TODO: sort example
    // set sort: true for enable
    garbageDetailAttr() {
      let fields = {
        fkkoName: {
          label: 'Наименование',
          validationRulePattern: '(\\.*)',
          placeholder: 'Введите название отхода',
          suggestion: {
            options: [],
            onSelect: this.onSelect,
            suggestionEndpoint: this.suggestionEndpoint,
            transformSuggestions: this.transformSuggestions,
          },
        },
        code: {
          sort: false,
          sortName: 'fkko_id',
          label: 'Код ФККО',
          required: true,
          placeholder: 'Выберите отход чтобы появился ФККО',
          disabled: true,
          validationRulePattern: '^((\\d*\\s*)*)$',
        },
        danger: {
          sort: false,
          label: 'Класс опасности',
          placeholder: 'цифра',
          required: true,
          disabled: true,
          validationRulePattern: '^([0-5])$',
        },
        start_year_value: {
          label: 'Количество на начало года, тонн',
        },
        start_year_value_cubic: {
          label: 'Количество на начало года, м<sup>3</sup>',
        },
        formed: {
          label: 'Образовано, тонн',
        },
        formed_cubic: {
          label: 'Образовано, м<sup>3</sup>',
        },
        input: {
          label: 'Поступило всего, тонн',
        },
        input_cubic: {
          label: 'Поступило всего, м<sup>3</sup>',
        },
        used: {
          label: 'Использовано, тонн',
        },
        used_cubic: {
          label: 'Использовано, м<sup>3</sup>',
        },
        processing: {
          label: 'Обработано, тонн',
        },
        processing_cubic: {
          label: 'Обработано, м<sup>3</sup>',
        },
        utilization: {
          label: 'Утилизировано всего, тонн',
        },
        utilization_cubic: {
          label: 'Утилизировано всего, м<sup>3</sup>',
        },
        utiled_to_recycle: {
          label: 'Утилизировано в т.ч. с целью рециклинга, тонн',
        },
        utiled_to_recycle_cubic: {
          label: 'Утилизировано в т.ч. с целью рециклинга, м<sup>3</sup>',
        },
        utiled_from_process: {
          label: 'Утилизировано в т.ч. после обработки, тонн',
        },
        utiled_from_process_cubic: {
          label: 'Утилизировано в т.ч. после обработки, м<sup>3</sup>',
        },
        neutralization: {
          label: 'Обезврежено всего, тонн',
        },
        neutralization_cubic: {
          label: 'Обезврежено всего, м<sup>3</sup>',
        },
        neutral_from_process: {
          label: 'Обезврежено в т.ч. после обработки, тонн',
        },
        neutral_from_process_cubic: {
          label: 'Обезврежено в т.ч. после обработки, м<sup>3</sup>',
        },
        output: {
          label: 'Передано всего, тонн',
        },
        output_cubic: {
          label: 'Передано всего, м<sup>3</sup>',
        },
        storage: {
          label: 'Размещено для хранения, тонн',
        },
        storage_cubic: {
          label: 'Размещено для хранения, м<sup>3</sup>',
        },
        burial: {
          label: 'Размещено для захоронения, тонн',
        },
        burial_cubic: {
          label: 'Размещено для захоронения, м<sup>3</sup>',
        },
        end_year_value: {
          label: 'Количество на конец года, тонн',
        },
        end_year_value_cubic: {
          label: 'Количество на конец года, м<sup>3</sup>',
        },
      }

      REGION_CONFIG.garbageDetailDisabledFields.forEach((fieldName) => {
        fields[fieldName].disabled = true
      })
      return fields
    },
    garbageInputAttr() {
      return {
        fkkoName: {
          label: 'Наименование',
          validationRulePattern: '(\\.*)',
          placeholder: 'Введите название отхода',
          suggestion: {
            options: [],
            onSelect: this.onSelect,
            suggestionEndpoint: this.suggestionEndpoint,
            transformSuggestions: this.transformSuggestions,
          },
        },
        code: {
          label: 'Код ФККО',
          required: true,
          placeholder: ' ',
          disabled: true,
          validationRulePattern: '^((\\d*\\s*)*)$',
        },
        danger: {
          label: 'Класс опасности',
          required: true,
          disabled: true,
          placeholder: 'цифра',
          validationRulePattern: '^([0-5])$',
        },
        count: {
          label: 'Количество отходов, тонн',
          required: true,
        },
        count_cubic: {
          label: 'Количество отходов, м<sup>3</sup>',
          required: true,
        },
        organizationName: {
          validationRulePattern: '(\\.*)',
          placeholder: 'Начните вводить название',
          label: 'Организация',
          suggestion: {
            options: [],
            onSelect: this.onSelectInputOrganization,
            suggestionEndpoint: this.suggestionOrganizationEndpoint,
            transformSuggestions: this.transformOrganizationSuggestions,
          },
        },
        region_code: {
          label: 'Регион',
          select: {
            options: this.regionsByCodes,
            disablePlaceholderOption: false,
          },
          transform: transformRegion.bind(this),
        },
      }
    },
    garbageOutputAttr() {
      return {
        fkkoName: {
          label: 'Наименование',
          validationRulePattern: '(\\.*)',
          placeholder: 'Введите название отхода',
          suggestion: {
            options: [],
            onSelect: this.onSelect,
            suggestionEndpoint: this.suggestionEndpoint,
            transformSuggestions: this.transformSuggestions,
          },
        },
        code: {
          label: 'Код ФККО',
          required: true,
          placeholder: ' ',
          disabled: true,
          validationRulePattern: '^((\\d*\\s*)*)$',
        },
        danger: {
          label: 'Класс опасности',
          required: true,
          disabled: true,
          placeholder: 'цифра',
          validationRulePattern: '^([0-5])$',
        },
        total: {
          label: 'Всего, тонн',
          required: true,
        },
        total_cubic: {
          label: 'Всего, м<sup>3</sup>',
        },
        region_code: {
          label: 'Направление',
          select: {
            options: this.regionsByCodes,
            disablePlaceholderOption: false,
          },
          transform: transformRegion.bind(this),
        },
        endOrganizationName: {
          validationRulePattern: '(\\.*)',
          placeholder: 'Начните вводить название организации',
          label: 'Организация, которой переданы отходы',
          suggestion: {
            options: [],
            onSelect: this.onSelectOrganization,
            suggestionEndpoint: this.suggestionOrganizationEndpoint,
            transformSuggestions: this.transformOrganizationSuggestions,
          },
        },
        tkoObjectName: {
          validationRulePattern: '(\\.*)',
          placeholder: 'Начните вводить название объекта',
          label: 'Объект обращения, которому переданы отходы',
          suggestion: {
            options: [],
            onSelect: this.onSelectTKO,
            suggestionEndpoint: this.suggestionTKOEndpoint,
            transformSuggestions: this.transformTKOSuggestions,
          },
        },
        use: {
          label: 'Передано для использования',
        },
        transportation: {
          label: 'Передано для транспортирования',
        },
        processing: {
          label: 'Передано на обработку',
        },
        utilization: {
          label: 'Передано на утилизацию',
        },
        neutralization: {
          label: 'Передано для обезвреживания',
        },
        storage: {
          label: 'Передано на хранение',
        },
        burial: {
          label: 'Передано на захоронение',
        },
      }
    },
    msnContainerAttr() {
      return {
        name: {
          label: this.msnContainerTitle,
          validationRulePattern: '(\\.*)',
          placeholder: 'Введите наименование контейнерной площадки',
          suggestion: {
            options: [],
            onSelect: this.onSelectMsn,
            suggestionEndpoint: this.msnSuggestionEndpoint,
            transformSuggestions: this.transformMsnSuggestions,
          },
        },
        volume: {
          label: 'Объем отправляемых отходов, куб.м.',
          validationRulePattern: '(\\.*)',
        },
      }
    },
    garbageDataUrl() {
      if (this.tableInOnlineMode) {
        let routeQuery = {
          query: {
            sourceId: this.id,
            year: this.year,
            type: this.operationType,
            garbage_type: 'default',
          },
        }
        if (this.search) {
          routeQuery.query.q = this.search
        }
        if (this.sort) {
          routeQuery.query.sort = this.sort
        }
        if (this.paginationQuery) {
          routeQuery.query = Object.assign(
            routeQuery.query,
            this.paginationQuery
          )
        }

        return garbage.garbageOperation(routeQuery)
      }
      // if new record, offline save
      return garbageOffline.garbageTable(
        this.$route.name,
        this.year,
        this.operationType
      )
    },
    garbageMsnUrl() {
      let routeQuery = {
        query: {
          garbage_source_id: this.id,
          year: this.year,
        },
      }
      return msn.garbageHouseOperation(routeQuery)
    },
    containerEnableOnAdd() {
      return ['name', 'volume']
    },
    regions() {
      return (
        (
          this.$store.getters.readUrlEndpoint(this.getCollectionEndpoint()) ||
          {}
        ).region || []
      )
    },
    regionsByCodes() {
      return this.regions.map((r) => ({
        ...r,
        id: r.code,
      }))
    },
  },
  methods: {
    fetchData() {
      let promises = []
      promises.push(
        this.$store.dispatch('updateUrlEndpoint', {
          endpoint: this.getCollectionEndpoint(),
        })
      )
      return Promise.all(promises)
    },
    getCollectionEndpoint() {
      return core.statuses({ fields: 'region' })
    },
    onPaginate(paginationQuery) {
      this.paginationQuery = paginationQuery
    },
    onSortByField({ sort }) {
      this.sort = sort
    },
    afterEditRow($event) {
      this.$emitter.emit(
        'garbage.garbageTable',
        Object.assign($event, {
          operationType: this.operationType,
          year: this.year,
        })
      )
    },
    afterValidate(ctx, model, errors) {
      if (errors.code) {
        delete errors.code
        errors.fkkoName = 'Выберите отход'
      }

      return errors
    },
    focusOnField(tr, name) {
      try {
        tr.querySelector('[name="' + name + '"]').focus()
      } catch (e) {
        console.error(e)
      }
    },
    afterFetchData(ctx, data) {
      for (let i = 0; i < data.data.length; i++) {
        data.data[i].garbage_type = 'default'
        if (data.data[i].fkko) {
          data.data[i].fkkoName = data.data[i].fkko.name

          if (!data.data[i].code) {
            data.data[i].code = data.data[i].fkko.code
          }
        } else {
          data.data[i].fkkoName = ''
        }
        if (
          data.data[i].endOrganization &&
          data.data[i].endOrganization.tko_operator_id
        ) {
          data.data[i].endOrganizationName = data.data[i].endOrganization.name
        }
        if (data.data[i].tko_object_id && data.data[i].tkoObject) {
          data.data[i].tkoObjectName = data.data[i].tkoObject.name
        }
        if (data.data[i].organization && data.data[i].organization_id) {
          data.data[i].organizationName = data.data[i].organization.name
        }
        if (
          data.data[i].garbageSource &&
          data.data[i].garbage_source_input_id
        ) {
          data.data[i].garbageSourceName = data.data[i].garbageSource.name
        }
      }
      return data
    },
    suggestionGarbageEndpoint(ctx, q) {
      return garbage.garbages({ query: { q: q, 'per-page': 50 } })
    },
    transformGarbageSuggestions(ctx, response) {
      let data = response.data
      let options = []
      for (let i = 0; i < data.length; i++) {
        options.push({
          name: data[i].name,
          id: data[i].id,
        })
      }
      return options
    },
    onSelectGarbage(ctx, $event, model) {
      if ($event && $event.id) {
        let copy = Object.assign({}, $event)
        model.garbage_source_input_id = copy.id
        model.garbageSourceName = this.$options.filters.stripHtml(copy.name)
      } else {
        model.garbage_source_input_id = ''
        model.garbageSourceName = ''
      }
    },
    onSelectInputOrganization(ctx, $event, model) {
      if ($event && $event.id) {
        let copy = Object.assign({}, $event)
        model.organization_id = copy.id
        model.organizationName = this.$options.filters.stripHtml(copy.name)
      } else {
        model.organization_id = ''
        model.organizationName = ''
      }
    },
    onSelectOrganization(ctx, $event, model) {
      if ($event && $event.id) {
        let copy = Object.assign({}, $event)
        model.tko_operator_id = copy.id
        model.endOrganizationName = this.$options.filters.stripHtml(copy.name)
      } else {
        model.tko_operator_id = ''
        model.endOrganizationName = ''
      }
    },
    suggestionOrganizationEndpoint(ctx, q) {
      return tko.operators({ query: { q: q, 'per-page': 50 } })
    },
    transformOrganizationSuggestions(ctx, response) {
      let data = response.data
      let options = []
      for (let i = 0; i < data.length; i++) {
        options.push({
          name: data[i].name,
          id: data[i].id,
        })
      }
      return options
    },
    onSelectTKO(ctx, $event, model) {
      if ($event && $event.id) {
        let copy = Object.assign({}, $event)
        model.tko_object_id = copy.id
        model.tkoObjectName = this.$options.filters.stripHtml(copy.name)
        model.tkoObject = {
          id: copy.id,
          name: model.tkoObjectName,
        }
      } else {
        model.tko_object_id = ''
        model.tkoObjectName = ''
        model.tkoObject = null
      }
    },
    suggestionTKOEndpoint(ctx, q) {
      return tko.objects({ query: { q: q, 'per-page': 50 } })
    },
    transformTKOSuggestions(ctx, response) {
      let data = response.data
      let options = []
      for (let i = 0; i < data.length; i++) {
        options.push({
          name: data[i].name,
          id: data[i].id,
        })
      }
      return options
    },
    onSelect(ctx, $event, model) {
      if (Object.assign({}, $event).is_rso === true) {
        this.$delete(this.garbageOutputAttr, 'total_cubic')
        this.$set(this.garbageOutputAttr.total, 'label', 'Всего, штук')

        this.$delete(this.garbageInputAttr, 'count_cubic')
        this.$set(
          this.garbageInputAttr.count,
          'label',
          'Количество отходов, штук'
        )

        const garbageDetailDeletingFields = [
          'start_year_value_cubic',
          'formed_cubic',
          'input_cubic',
          'used_cubic',
          'processing_cubic',
          'utilization_cubic',
          'utiled_to_recycle_cubic',
          'utiled_from_process_cubic',
          'neutralization_cubic',
          'neutral_from_process_cubic',
          'output_cubic',
          'storage_cubic',
          'burial_cubic',
          'end_year_value_cubic',
        ]
        garbageDetailDeletingFields.forEach((fieldName) =>
          this.$delete(this.garbageDetailAttr, fieldName)
        )
        this.$set(
          this.garbageDetailAttr.start_year_value,
          'label',
          'Количество на начало года, штук'
        )
        this.$set(this.garbageDetailAttr.formed, 'label', 'Образовано, штук')
        this.$set(
          this.garbageDetailAttr.input,
          'label',
          'Поступило всего, штук'
        )
        this.$set(this.garbageDetailAttr.used, 'label', 'Использовано, штук')
        this.$set(
          this.garbageDetailAttr.processing,
          'label',
          'Обработано, штук'
        )
        this.$set(
          this.garbageDetailAttr.utilization,
          'label',
          'Утилизировано всего, штук'
        )
        this.$set(
          this.garbageDetailAttr.utiled_to_recycle,
          'label',
          'Утилизировано в т.ч. с целью рециклинга, штук'
        )
        this.$set(
          this.garbageDetailAttr.utiled_from_process,
          'label',
          'Утилизировано в т.ч. после обработки, штук'
        )
        this.$set(
          this.garbageDetailAttr.neutralization,
          'label',
          'Обезврежено всего, штук'
        )
        this.$set(
          this.garbageDetailAttr.neutral_from_process,
          'label',
          'Обезврежено в т.ч. после обработки, штук'
        )
        this.$set(
          this.garbageDetailAttr.output,
          'label',
          'Передано всего, штук'
        )
        this.$set(
          this.garbageDetailAttr.storage,
          'label',
          'Размещено для хранения, штук'
        )
        this.$set(
          this.garbageDetailAttr.burial,
          'label',
          'Размещено для захоронения, штук'
        )
        this.$set(
          this.garbageDetailAttr.end_year_value,
          'label',
          'Количество на конец года, штук'
        )

        this.$
      }

      if ($event && $event.id) {
        let copy = Object.assign({}, $event)
        model.code = copy.code
        model.fkko_id = copy.id
        model.fkkoName = copy.fkkoName
        model.fkko = { name: copy.fkkoName }
        model.danger = copy.danger
      } else {
        model.code = ''
        model.fkko_id = ''
        model.fkkoName = ''
        model.fkko = { name: '' }
        model.danger = ''
      }
    },
    suggestionEndpoint(ctx, q) {
      const query = { q: q, 'per-page': 50 }
      if (this.hasGarbageFkkoAll) {
        query.has_danger_only = 0
      }
      return cadastr.fkko({
        query,
      })
    },
    transformSuggestions(ctx, response) {
      let data = response.data
      let options = []
      for (let i = 0; i < data.length; i++) {
        options.push({
          name: data[i].code + ' ' + data[i].name,
          fkkoName: data[i].name,
          is_rso: data[i].is_rso,
          id: data[i].id,
          code: data[i].code,
          danger: data[i].danger,
        })
      }
      return options
    },
    garbagePostUrl() {
      return garbage.garbageOperationPost({
        query: {
          sourceId: this.id,
          year: this.year,
          type: this.operationType,
        },
      })
    },
    garbagePatchUrl(context, model) {
      return garbage.garbageOperationPatch({
        query: {
          sourceId: model.id,
          year: model.year,
          type: this.operationType,
        },
      })
    },
    garbageDeleteUrl(context, model) {
      return garbage.garbageOperationDelete({
        query: {
          sourceId: model.id,
          year: model.year,
          type: this.operationType,
        },
      })
    },
    msnSuggestionEndpoint(ctx, q) {
      return msn.containers(
        {
          query: { q: q, 'per-page': 50 },
        },
        'with_containers'
      )
    },
    onSelectMsn(ctx, $event, model) {
      this.suggestedMsnGarbage = $event.id
      model.msn_id = this.suggestedMsnGarbage
      model.name = $event.name
    },
    afterFetchContainerData(ctx, data) {
      for (let i = 0; i < data.data.length; i++) {
        if (data.data[i]) {
          data.data[i].name = this.hasMsnContainerAddress
            ? data.data[i].msn.address
            : data.data[i].msn.name
        }
      }
      const currentPlan = findItemByPropertyAndValue(
        this.year_meter_plans,
        'year',
        this.year
      )
      if (currentPlan) {
        const volumes = reduceArrayByOneProperty(data.data, 'volume')
        this.year_meter_plan = Number(currentPlan.year_meter_plan)
        this.leftVolume = (this.year_meter_plan - volumes).toFixed(2)
      }
      return data
    },
    msnGarbagePostUrl() {
      return msn.garbageHouseOperationPost()
    },
    msnGarbagePatchUrl(context, model) {
      return msn.garbageHouseOperationPath(model.id)
    },
    msnGarbageDeleteUrl(context, model) {
      return msn.garbageHouseOperationDelete(model.id)
    },
    prepareContainerRow(model) {
      return model
    },
    transformMsnSuggestions(ctx, response) {
      let data = response.data
      let options = []
      for (let i = 0; i < data.length; i++) {
        options.push({
          name: this.hasMsnContainerAddress ? data[i].address : data[i].name,
          id: data[i].id,
        })
      }
      return options
    },
    prepareModel() {
      const Model = () => {
        let code = ''
        let fkkoName = ''
        let danger = ''
        let fkko = { name: '' }
        let fkko_id = ''
        let formed = ''
        if (REGION_CONFIG.defaultGarbageFkko) {
          code = REGION_CONFIG.defaultGarbageFkko.code
          danger = REGION_CONFIG.defaultGarbageFkko.danger
          fkkoName = REGION_CONFIG.defaultGarbageFkko.fkkoName
          fkko.name = REGION_CONFIG.defaultGarbageFkko.fkkoName
          fkko_id = REGION_CONFIG.defaultGarbageFkko.fkkoId
        }
        if (this.hasGarbageOperationsFormedByCurrentYear) {
          const operation = this.fields.operations?.find(
            (item) => item.year === this.year
          )
          formed = operation?.year_kg_fact
        }

        return {
          code,
          fkkoName,
          danger,
          fkko,
          fkko_id,
          formed,
          garbage_type: 'default',
          // can be used for turn year select
          _operationType: JSON.parse(JSON.stringify(this.operationType)),
          _year: JSON.parse(JSON.stringify(this.year)),
          region_code: REGION_CONFIG.regionCode,
        }
      }
      return Model
    },
    addNewRowToGarbageTable() {
      const Model = this.prepareModel()
      const containerModel = () => {
        return {
          name: '',
          volume: '',
          year: JSON.parse(JSON.stringify(this.year)),
          type: 1,
          msn_id: this.suggestedMsnGarbage,
          garbage_source_id: this.id,
        }
      }

      if (this.operationType === 'detail') {
        this.$refs.detail.createRow(new Model())
      } else if (this.operationType === 'input') {
        this.$refs.input.createRow(new Model())
      } else if (this.operationType === 'output') {
        this.$refs.output.createRow(new Model())
      } else if (this.operationType === 'container') {
        this.$refs.container.createRow(new containerModel())
      }
    },
    onSelectYear(year) {
      this.year = year
      this.year_meter_plan = null
      this.leftVolume = null
    },
    async afterSaveContainerRow() {
      const response = await this.$store.dispatch('updateUrlEndpoint', {
        endpoint: this.garbageMsnUrl,
        fromCache: false,
      })
      this.afterFetchContainerData(null, response.data)
    },
    onToggleEditable(value) {
      this.$router.push({
        name: 'msn.withContainers.update',
        params: { id: value.msn.id },
        query: {
          prevRoute: url.getRoute(this.$route, true),
        },
      })
    },
  },
  created() {
    this.fetchData()
  },
}
</script>
